import { createSelector } from 'reselect';
import getPhoneVerified from '@core/reducers/user/selectors/getPhoneVerified';
import { getIsUserLogged } from '@shared/selectors';

const getShowPhoneValidationModalForCart = createSelector(
  getPhoneVerified,
  getIsUserLogged,
  (isPhoneVerified, isUserLogged) => isUserLogged && !isPhoneVerified,
);

export default getShowPhoneValidationModalForCart;
